import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnnouncementsComponent } from './announcements.component';
import { AddAnnouncementComponent } from './add-announcement/add-announcement.component';
import { EditAnnouncementComponent } from './edit-announcement/edit-announcement.component';
import { AngularMaterialModule } from '@app/angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@app/directives/directives.module';
import { HubSharedComponentsModule } from '@app/shared/components/hub-shared-components.module';

@NgModule({
  declarations: [AnnouncementsComponent, AddAnnouncementComponent, EditAnnouncementComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    HubSharedComponentsModule
  ]
})
export class AnnouncementsModule {}
